module.exports = __webpack_public_path__ + "res-static/img/logo-flat.7fb66177.svg";